import {JsonApiResponse} from '@/types/JsonApiResponse.interface';
import {JsonApiResponseSchema} from '@/schema/JsonApiResponse.schema';
import {EventBasesServiceInterface} from './EventBasesService.interface';
import {EventBasesServiceSchema} from './EventBasesService.schema';
import {API} from '@/api/API';
import {postData} from '@/utils/sendData';
import JSONAPI from '@/utils/JSONAPI/JSONAPI';
import camelcaseKeys from 'camelcase-keys';
import {JsonApiQueryParamsInterface} from '@/types/JsonApiQueryParams.interface';
import snakecaseKeys from "snakecase-keys";

export const getEventBasesList = async (params?: JsonApiQueryParamsInterface): Promise<JsonApiResponse<EventBasesServiceInterface[]>> => {
    const fallback: JsonApiResponse<EventBasesServiceInterface[]> = {
        data: [EventBasesServiceSchema],
        meta: JsonApiResponseSchema.meta,
    };

    const url = API.getEventBasesBlocks.path(params);
    const method = API.getEventBasesBlocks.method;

    try {
        const response = await postData(null, url, method, null);
        const data = await JSONAPI.deserialize<EventBasesServiceInterface[]>(response.data);
        const meta = {...fallback.meta, ...(response.data.meta?.page ?? {})};
        const result = camelcaseKeys({...fallback, data, meta}, {deep: true});

        return result as JsonApiResponse<EventBasesServiceInterface[]>;
    } catch (e) {
        console.error('[getEventBasesList]', e);
        return fallback;
    }
};
